module.exports = __webpack_public_path__ + "pc/img/puzzle_bg_03.e5b6a2d1.png";